export default __webpack_public_path__ + "static/media/title.4545aed7.svg";